module.exports = __webpack_public_path__ + "4b689e2f.jpg";